module.exports = __webpack_public_path__ + "static/ict_consulting-bf45d8e257fc2798f5182706908cd409.svg";